import { render, staticRenderFns } from "./RowOfSeats.vue?vue&type=template&id=22d97660&scoped=true&"
import script from "./RowOfSeats.vue?vue&type=script&lang=js&"
export * from "./RowOfSeats.vue?vue&type=script&lang=js&"
import style0 from "./RowOfSeats.vue?vue&type=style&index=0&id=22d97660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d97660",
  null
  
)

export default component.exports